import { render, staticRenderFns } from "./DetailsTicketAppointmentBox.vue?vue&type=template&id=7c7ecb2e"
import script from "./DetailsTicketAppointmentBox.vue?vue&type=script&lang=ts"
export * from "./DetailsTicketAppointmentBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports